// extracted by mini-css-extract-plugin
module.exports = {"wrapdbs":"styles_wrapdbs__2VREl","qrcode":"styles_qrcode__1UEHF"};